export default __webpack_public_path__ + "static/media/green-tick.b715e0ba.svg";